export const LOCAL_DB_NAME = "delivery-driver";
